import { z } from 'zod'
import { relatedSchema } from '~/schemas'
import { fetchApi } from './helpers'

export const fetchRelatedData = async ({ id }: { id: string }) => {
  const response: any = await fetchApi(`/pages/${id}/related`)

  const items = z.array(relatedSchema).parse(
    response.items?.map((item: Record<string, any>) => ({
      id: item.related?.data?.id,
      parentId: item.related?.data?.parent_id,
      image: item.related?.media?.[0]?.data?.url,
      path: item.related?.extra?.url?.data?.url,
      title: item.related?.extra?.translation?.data?.name,
      favourited: item.related?.extra?.favourited,
    })),
  )

  const total = z.number().parse(response.total)

  return { items, total }
}

export type RelatedData = Awaited<ReturnType<typeof fetchRelatedData>>
